  <template>
    <section class="components-dashbord-all-ticked mb-5">
        <div class="container-fluid">
            <div class="row">
                <div class="col">
                    <h4 class="text-right rtl font-18 mb-4">
                        {{title}}
                    </h4>
                    <div v-for="(item,index) in 4" :key="index">
                        <!-- v-b-toggle="'div'+index" -->
                        <div class="d-flex flex-row card-header" v-b-toggle="'div'+index">
                            <toggle-open/>
                            <p class="mb-0 justify-content-star text-right ml-auto font-14 d-inline-block text-info">
                                عنوان تیکت
                            </p>
                            <!-- v-b-toggle="'ans'+index" -->
                            <p class="mb-0 justify-content-end d-flex  font-14 mr-auto d-inline-block text-info">
                                سه جواب داده شده
                            </p>
                        </div>
                        <b-collapse :id="'div'+index" :visible="index === expanded" accordion="my-accordion">
                            <div class="content px-2 py-3">
                                <div class="d-flex row-item py-2">
                                    <div class="title col-6  justify-content-start rtl text-right">
                                        <p class="mb-0 text-right font-14 d-inline-block">
                                            متن تیکت متن تیکت متن تیکت متن تیکت متن تیکت متن تیکت
                                        </p>
                                    </div>
                                    <div class="title col-6  justify-content-start rtl text-left">
                                        <p class="mb-0 text-right font-14 d-inline-block text-secondary" v-b-toggle="'ans'+index">
                                            جواب ها
                                        </p>
                                        <!-- v-b-toggle="'ans'+index+2" -->
                                        <p class="mb-0 text-right font-14 d-inline-block text-info" v-b-toggle="'newAns'+index">
                                            پاسخ دهید
                                        </p>
                                    </div>
                                </div>

                                <b-collapse visible :id="'newAns'+index">
                                    <div class="row row-item-ans p-3">
                                        <div class="col-12">
                                            <contact-form :inputs="newTiket" :title="'تیکت جدید'" class="mb-4" :action="true" />
                                        </div>
                                    </div>
                                </b-collapse>
                                <b-collapse :id="'ans'+index">

                                    <div class="row row-item-ans p-3" v-for="item in 2">
                                        <div class="title col-12  justify-content-start rtl text-right">
                                            <p class="mb-0 text-right font-14 d-inline-block">
                                                کاربر :
                                                <span>
                                                    adli {{item}}
                                                </span>
                                            </p>
                                        </div>
                                        <div class="info col-12  justify-content-start rtl text-right">
                                            <p class="mb-0 text-right font-14 d-inline-block">
                                                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Repellendus praesentium eius minima inventore vitae fugit distinctio similique natus eveniet nesciunt, rem, dicta delectus deserunt, expedita cumque ab! Debitis, aspernatur omnis?
                                            </p>
                                        </div>
                                    </div>
                                </b-collapse>

                            </div>
                        </b-collapse>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import toggleOpen from 'cp/min-component/open-colose.vue'
import contactForm from 'cp/contact-form.vue'

export default {
  props: ['title'],
  name: 'components-dashbord-all-ticked',
  components: {
    toggleOpen,
    contactForm
  },
  methods: {

  },
  data () {
    return {
      open: true,
      expanded: 1,
      text: `Anim pariatur clichemus labore VHS.`,
      newTiket: [
        {
          type: 'textarea',
          name: 'msg',
          label: 'متن',
          model: '',
          msg: 'فیلد متن نباید خالی باشد',
          col: '12',
          star: true,
          rule: 'required'
        }
      ]
    }
  },
  mounted () {
    var vm = this
    setTimeout(() => {
      vm.expanded = 0
    }, 0.4)
  }
}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
@blueLine: #007791;
.components-dashbord-all-ticked {
  .box-clear;
  .card-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    background: #f9f9f9;
    border: 1px solid @e3;
    cursor: pointer;
    height: auto;
    margin-top: 3px;
    padding: 10px 15px 10px 10px;
    color: @secondaryTextColor;
    i {
      margin-left: 10px;
    }
  }
  .content {
    background-color: @withe;
  }
  .row-item {
    border-bottom: 1px solid @e3;
    &:last-child {
      border-bottom: none;
    }
    .title {
      p {
        cursor: pointer;
      }
      color: @blueLine;
      i {
        transform: scale(-1, -1);
      }
    }
    .info {
      color: @blueLine;
      p {
        cursor: pointer;
      }
    }
  }
  .row-item-ans {
    border-bottom: 1px solid @e3;
    &:last-child {
      border-bottom: none;
    }
    .title {
      p {
        cursor: pointer;
      }
      span {
        color: @blueLine;
      }
      color: @primaryTextColor;
      i {
        transform: scale(-1, -1);
      }
    }
    .info {
      color: @darkPrimaryColor;
      p {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard-component/all-ticked.vue